import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { ResponseDto } from '@diritto/common/base/response.dto';
import { PromotionReplyApi } from 'api/ApiHelper';

export const useDeletePromotionReplyMutation = (
  promotionId: number,
  options?: UseMutationOptions<ResponseDto, unknown, string>,
) =>
  useMutation({
    mutationFn: (replyId: string) => PromotionReplyApi.deletePromotionReply(promotionId, replyId),
    ...options,
  });
